import { render } from "./MMMiningVideo.vue?vue&type=template&id=ef26ba72"
import script from "./MMMiningVideo.vue?vue&type=script&lang=js"
export * from "./MMMiningVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__